'use strict';

import React from 'react';
import { useEffect, useState, useContext } from 'react';

import { Table, Button, OverlayTrigger, Tooltip, Popover } from 'react-bootstrap';

import useRequest from '../helper/useRequest';
import { formatDate, formatTime, getDateFromString } from '../helper/DateTimeFormater';
import { toast } from 'react-toastify';
import useConfirmation from '../helper/Confirmation';
import AppContext from '../AppContext';
import Loader from '../helper/Loader';

import TableHeader from '../helper/TableHeader';
import { customFilterFunction } from '../helper/CustomFilter';

import Select from 'react-select';

import TimeslotEdit from './TimeslotEdit';

import {
    createColumnHelper,
    flexRender,
    getCoreRowModel,
    getSortedRowModel,
    getFilteredRowModel,
    useReactTable,
} from '@tanstack/react-table'

const columnHelper = createColumnHelper();

function TimeslotsOperator() {
    const { request } = useRequest();
    const context = useConfirmation();
    const { getSalutation, User } = useContext(AppContext);

    const [realTimeslots, setRealTimeslots] = useState(false);
    const [timeslots, setTimeslots] = useState(false);
    const [sorting, setSorting] = useState([]);
    const [columnFilters, setColumnFilters] = useState([]);

    const [statusFilter, setStatusFilter] = useState({ value: 0, label: "alle" });
    const [periodFilter, setPeriodFilter] = useState({ value: 1, label: "aktuelle" });
    const [modal, setModal] = useState(false);
    const [timeslot, setTimeslot] = useState(false);
    const now = new Date();
    const [year, setYear] = useState({ value: now.getFullYear(), label: now.getFullYear() });
    const [years, setYears] = useState(false);

    console.log(realTimeslots);


    const getBusinessContact = (booked, contact, sndContact) => {
        if (!booked) return "";
        return sndContact.SalutationID != '0' ? (
            <>
                <div><a href={"/Operator/Business/" + booked.OrganisationID}>{booked.OrganisationName}, {booked.Street} {booked.HouseNo} {booked.PostCode} {booked.City}</a></div>
                <div>{(contact.SalutationID == 3) ? "---" : getSalutation(contact.SalutationID)} {contact.Title} {contact.FirstName} {contact.LastName} ({contact.Email})</div>
                <div>{(sndContact.SalutationID == 3) ? "---" : getSalutation(sndContact.SalutationID)} {sndContact.Title} {sndContact.FirstName} {sndContact.LastName} ({sndContact.Email})</div>
            </>
        ) : (
            <>
                <div><a href={"/Operator/Business/" + booked.OrganisationID}>{booked.OrganisationName}, {booked.Street} {booked.HouseNo} {booked.PostCode} {booked.City}</a></div>
                <div>{(contact.SalutationID == 3) ? "---" : getSalutation(contact.SalutationID)} {contact.Title} {contact.FirstName} {contact.LastName} ({contact.Email})</div>
            </>
        );
    }

    const getSchoolContact = (timeslot, contact) => {
        if (!timeslot) return "";
        if (!contact) return "";
        return (
            <>
                {(timeslot.AdditionToAddress == "" || timeslot.AdditionToAddress == null)
                    ? <div><a href={"/Operator/School/" + timeslot.OrganisationID}>{timeslot.OrganisationName}, {timeslot.Street} {timeslot.HouseNo}, {timeslot.PostCode} {timeslot.City}</a></div>
                    : <div><a href={"/Operator/School/" + timeslot.OrganisationID}>{timeslot.OrganisationName}, {timeslot.Street} {timeslot.HouseNo}, {timeslot.AdditionToAddress}, {timeslot.PostCode} {timeslot.City}</a></div>}
                <div>{(contact.SalutationID == 3) ? "---" : getSalutation(contact.SalutationID)} {contact.Title} {contact.FirstName} {contact.LastName} ({contact.Email})</div>
            </>
        );
    }

    const cancelTimeslot = async (id) => {
        try {
            let result = await request("/Operator/CancelTimeslot", { timeslotId: id });
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.error(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten.");
                }
            }
            else {
                toast.success("Zeitsatz storniert.");
                updateTimeslots(id);
            }
        }
        catch (ex) {
            console.error(ex);
            toast.error("Es ist ein Fehler aufgetreten.");
        }
    };

    const deleteTimeslot = async (id) => {
        try {
            let result = await request("/Operator/DeleteTimeslot", { timeslotId: id });
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.error(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten.");
                }
            }
            else {
                toast.success("Zeitsatz gelöscht.");
                updateTimeslots(id);
            }
        }
        catch (ex) {
            console.error(ex);
            toast.error("Es ist ein Fehler aufgetreten.");
        }
    };

    const selectTimeslot = (id) => {
        const slot = realTimeslots.find(item => item.TimeslotID == id);

        if (!slot) return;
        setModal(true);
        setTimeslot({ ...slot });
    }

    const columns = [
        columnHelper.accessor('StatusString', {
            header: () => (
                <OverlayTrigger popperConfig={{
                    modifiers: {
                        name: "offset",
                        options: {
                            offset: [0, 20]
                        }
                    }
                }} placement="left" overlay={(
                    <Popover id="slot-status-info">
                        <Popover.Header as="h3">Status</Popover.Header>
                        <Popover.Body>
                            <div><span className="bookedCircle me-2"></span>offen</div>
                            <div><span className="bookedCircle booked me-2"></span>gebucht</div>
                            <div><span className="bookedCircle canceled me-2"></span>storniert</div>
                            <div><span className="bookedCircle deleted me-2"></span>gelöscht</div>
                        </Popover.Body>
                    </Popover>
                )}>
                    <span>Status</span>
                </OverlayTrigger>
            ),
            cell: info => {
                let statusCircle = <span className="bookedCircle"></span>;
                if (info.getValue() == "gebucht") {
                    statusCircle = <span className="bookedCircle booked"></span>;
                }
                else if (info.getValue() == "storniert") {
                    statusCircle = <span className="bookedCircle canceled"></span>;
                } else if (info.getValue() == "gelöscht") {
                    statusCircle = <span className="bookedCircle deleted"></span>;
                }

                return (
                    <OverlayTrigger placement="left" overlay={<Tooltip>{info.getValue()}</Tooltip>}>
                        <>{statusCircle} {info.getValue()}</>
                    </OverlayTrigger>
                );
            },
            enableColumnFilter: true,
            filterFn: customFilterFunction,
            meta: {
                filterComponent: "select",
            }
        }),
        columnHelper.accessor('Appointment', {
            header: () => <span>Datum</span>,
            cell: info => {
                return formatDate(info.getValue())
            },
            enableColumnFilter: true,
        }),
        columnHelper.accessor('TimeStart', {
            header: () => <span>Startzeit</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('TimeEnd', {
            header: () => <span>Endzeit</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('ExpireTime', {
            header: () => <span>Ablaufzeit</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('Grade', {
            header: () => <span>Stufe</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('Class', {
            header: () => <span>Klasse</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('Room', {
            header: () => <span>Raum</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('Equipment', {
            header: () => <span>Ausstattung</span>,
            cell: info => info.getValue(),
            enableSorting: false,
            enableColumnFilter: true,
        }),
        columnHelper.accessor('ContactBusinessString', {
            header: () => <span>Buchende Organisation</span>,
            cell: info => {
                return getBusinessContact(info.row.original.BookedOrganisation, info.row.original.ContactOrganisation, info.row.original.SndContactOrganisation);
            },
            enableSorting: false,
            enableColumnFilter: true,
        }),
        columnHelper.accessor('ContactSchoolString', {
            header: () => <span>Erstellende Schule</span>,
            cell: info => {
                return getSchoolContact(info.row.original, info.row.original.ContactSchool);
            },
            enableSorting: false,
            enableColumnFilter: true,
        }),
        //columnHelper.accessor('CriminalRecord', {
        //    header: () => <span>Führungszeugnis</span>,
        //    cell: info => {
        //        return info.row.original.CriminalRecord ? <i class="fas fa-lg fa-check"></i> : <i class="fas fa-lg fa-xmark"></i>
        //    },
        //    enableSorting: true,
        //    enableColumnFilter: false,
        //}),
        columnHelper.accessor('TimeslotID', {
            size: 120,
            header: () => <span></span>,
            cell: info => {
                let d = getDateFromString(info.row.original.AppointmentDescription, info.row.original.TimeStart);

                if (d < now) {
                    return <div>
                        <div className="d-grid"><Button variant="warning" className="float-end" onClick={() => selectTimeslot(info.getValue())}>Bearbeiten</Button></div>
                        <div className="d-grid"><Button variant="danger" className="float-end" onClick={() => context.openModal("Wirklich löschen?", "Möchten Sie diesen Termin wirklich löschen?", () => { deleteTimeslot(info.getValue()) }, "Ja", "Nein")}>Löschen</Button></div>
                    </div>
                }
                if (info.row.original.BookedBusiness == 0) {
                    return <div>
                        <div className="d-grid"><Button variant="warning" className="float-end" onClick={() => selectTimeslot(info.getValue())}>Bearbeiten</Button></div>
                        <div className="d-grid"><Button variant="danger" className="float-end" onClick={() => context.openModal("Wirklich löschen?", "Möchten Sie diesen Termin wirklich löschen?", () => { deleteTimeslot(info.getValue()) }, "Ja", "Nein")}>Löschen</Button></div>
                    </div>;
                }
                else {
                    return <div>
                        <div className="d-grid"><Button variant="warning" className="float-end" onClick={() => selectTimeslot(info.getValue())}>Bearbeiten</Button></div>
                        <div className="d-grid"><Button variant="danger" className="float-end" onClick={() => context.openModal("Wirklich stornieren?", "Möchten Sie diesen Termin wirklich stornieren?", () => { cancelTimeslot(info.getValue()) }, "Ja", "Nein")}>Stornieren</Button></div>
                        <div className="d-grid"><Button variant="danger" className="float-end" onClick={() => context.openModal("Wirklich löschen?", "Möchten Sie diesen Termin wirklich löschen?", () => { deleteTimeslot(info.getValue()) }, "Ja", "Nein")}>Löschen</Button></div>
                    </div>;
                }
            },
            enableSorting: false,
            enableColumnFilter: false,
        }),
    ]

    const reactTable = useReactTable({
        data: timeslots || [],
        columns,
        state: {
            sorting,
            columnFilters
        },
        onSortingChange: setSorting,
        onColumnFiltersChange: setColumnFilters,

        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
    })

    const statusList = [
        { value: 0, label: "alle" },
        { value: 1, label: "offen" },
        { value: 2, label: "gebucht" },
        { value: 3, label: "storniert" },
        { value: 4, label: "gelöscht" },
        { value: 5, label: "Systemlöschung" },
        { value: 6, label: "zurückgesetzt" },
    ];

    const periodList = [
        { value: 0, label: "alle" },
        { value: 1, label: "aktuelle" },
        { value: 2, label: "vergangene" },
    ];

    const updateTimeslots = (id) => {
        setRealTimeslots((items) => {
            var newItems = items.filter((timeslot) => {
                if (timeslot.TimeslotID == id) {
                    return false;
                }
                return true;
            });
            return newItems;
        });
    };

    const editTimeslot = async (timeslot) => {
        setRealTimeslots((items) => {
            return items.map((item) => {
                if (item.TimeslotID == timeslot.TimeslotID) {
                    item.Appointment = timeslot.Appointment;
                    item.TimeStart = timeslot.TimeStart;
                    item.TimeEnd = timeslot.TimeEnd;
                    item.Grade = timeslot.Grade;
                    item.Class = timeslot.Class;
                    item.Room = timeslot.Room;
                    item.Equipment = timeslot.Equipment;
                    item.Category = timeslot.Category;
                    item.ExpireTime = timeslot.ExpireTime;
                    item.ContactPersonSchool = timeslot.ContactPersonSchool;
                    item.ContactSchool = timeslot.ContactSchool;
                    item.ContactPersonOrganisation = timeslot.ContactPersonOrganisation;
                    item.ContactOrganisation = timeslot.ContactOrganisation;
                    item.SndContactPersonOrganisation = timeslot.SndContactPersonOrganisation;
                    item.SndContactOrganisation = timeslot.SndContactOrganisation;
                }

                return item;
            })
        });
        if (!realTimeslots) return;
        filterSlots(realTimeslots);
    }

    const filterSlots = (realSlots) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        let slots = [];
        if (periodFilter.value == 0) {
            slots = realSlots;
        }
        else if (periodFilter.value == 1) {
            slots = realSlots.filter(i => new Date(i.Appointment + " " + i.TimeStart) >= today);
        }
        else if (periodFilter.value == 2) {
            slots = realSlots.filter(i => new Date(i.Appointment + " " + i.TimeStart) <= today);
        }

        slots = slots.map(item => {

            const schoolContact = item.ContactSchool;
            const newItem = { ...item };

            newItem.ExpireTime = item.ExpireTime + "";
            newItem.Equipment = newItem.Equipment.map((i) => { return i.Description; }).join("; ");
            newItem.AppointmentDescription = formatDate(item.Appointment);
            newItem.TimeStart = formatTime(item.TimeStart);
            newItem.TimeEnd = formatTime(item.TimeEnd);

            if (item.BookedOrganisation) {
                const booked = item.BookedOrganisation;
                const contact = item.ContactOrganisation;
                const sndContact = item.SndContactOrganisation;
                newItem.ContactBusinessString = booked.OrganisationName + ", " + booked.Street + " " + booked.HouseNo + " " + booked.PostCode + " " + booked.City + " " + getSalutation(contact.SalutationID) + " " + contact.FirstName + " " + contact.LastName + " " + contact.Email;
                if (sndContact && sndContact.Email) {
                    newItem.ContactBusinessString += " " + getSalutation(sndContact.SalutationID) + " " + sndContact.FirstName + " " + sndContact.LastName + " " + sndContact.Email;
                }
            }

            if (item.AdditionToAddress) {
                newItem.ContactSchoolString = item.OrganisationName + ", " + item.Street + " " + item.HouseNo + ", " + item.AdditionToAddress + ", " + item.PostCode + " " + item.City + " " + schoolContact.SalutationID + " " + schoolContact.Title + " " + schoolContact.FirstName + " " + schoolContact.LastName + " " + schoolContact.Email;
            }
            else {
                newItem.ContactSchoolString = item.OrganisationName + ", " + item.Street + " " + item.HouseNo + ", " + item.PostCode + " " + item.City + " " + getSalutation(schoolContact.SalutationID) + " " + schoolContact.Title + " " + schoolContact.FirstName + " " + schoolContact.LastName + " " + schoolContact.Email;
            }

            return newItem;
        });

        setTimeslots(slots);
    }

    const getTimeslots = async () => {
        try {
            let result = await request("/Operator/GetAllTimeslots", { year: year.value });
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.info(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
                }

                setTimeslots([]);
                setRealTimeslots([]);
            }
            else {
                //filterSlots(json.timeslots);
                setRealTimeslots(json.timeslots);

                if (json.timeslots.length == 0) {
                    toast.info("Es wurden keine Termine gefunden.");
                }
            }
        }
        catch {
            toast.error("Laden der Termine fehlgeschlagen.");
        }
    };

    const initTimeslots = async () => {
        try {
            let result = await request("/Operator/InitTimeslots", { year: year.value });
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.info(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
                }

                setTimeslots([]);
                setRealTimeslots([]);
            }
            else {
                setRealTimeslots(json.timeslots);
                setYears(json.years.map(item => { return { value: item, label: item } }));

                if (json.timeslots.length == 0) {
                    toast.info("Es wurden keine Termine gefunden.");
                }
            }
        }
        catch {
            toast.error("Laden der Termine fehlgeschlagen.");
        }
    }

    useEffect(() => {
        if (!realTimeslots) return;
        filterSlots(realTimeslots);
    }, [statusFilter, periodFilter, realTimeslots]);

    useEffect(() => {
        if (!year || !years) return;
        setTimeslots(false);
        getTimeslots();
    }, [year]);

    useEffect(() => {
        initTimeslots();
    }, [])

    if (timeslots === false) return <Loader />

    /*
     <div className="mb-2 me-2" style={{ width: "220px" }}>
        <label>Status</label>
        <Select menuPortalTarget={document.body}
            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            menuPosition={"fixed"} name="filterStatus" options={statusList} value={statusFilter} className="basic-multi-select" placeholder="Bitte auswählen" onChange={(values) => { setStatusFilter(values) }} />
            
     </div>
    */

    return <>
        <div className='mb-3' style={{ display: "flex", alignItems: "center", width: "100%" }}>
            <div className="mb-2 me-2" style={{ width: "150px" }}>
                <label>Jahr</label>
                <Select menuPortalTarget={document.body}
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    menuPosition={"fixed"} name="filterStatus" options={years} value={year} className="basic-multi-select" placeholder="Bitte auswählen" onChange={(values) => { setYear(values) }} />

            </div>
            <div className="mb-2 me-2" style={{ width: "220px" }}>
                <label>Zeitraum</label>
                <Select menuPortalTarget={document.body}
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    menuPosition={"fixed"} name="filterPeriod" options={periodList} value={periodFilter} className="basic-multi-select" placeholder="Bitte auswählen" onChange={(values) => { setPeriodFilter(values) }} />
            </div>
        </div>
        <Table striped>
            <thead>
                {reactTable.getHeaderGroups().map(headerGroup => (
                    <TableHeader key={headerGroup.id} table={reactTable} headerGroup={headerGroup} flexRender={flexRender} />
                ))}
            </thead>
            <tbody>
                {reactTable.getRowModel().rows.map(row => (
                    <tr key={row.id}>
                        {row.getVisibleCells().map(cell => {
                            return (
                                <td key={cell.id}>
                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                </td>
                            )
                        })}
                    </tr>
                ))}
            </tbody>
        </Table>
        <TimeslotEdit timeslot={timeslot} open={modal} setOpen={setModal} editTimeslot={editTimeslot} />
    </>
}

export default TimeslotsOperator;